/**
 * DataGrid ning o'z yozuvlari.
 *
 * MUI jadvali sukut bo'yicha inglizcha gapiradi -- "No rows", "Rows per page".
 * Panelning qolgan qismi o'zbekcha bo'lgani uchun bu yozuvlar begona ko'rinardi.
 * Bir joyda turgani ma'qul: jadval ikkita sahifada ishlatiladi.
 */
const gridLocale = {
  noRowsLabel: "Ma'lumot yo'q",
  noResultsOverlayLabel: "Hech narsa topilmadi",
  errorOverlayDefaultLabel: "Xatolik yuz berdi",

  footerRowSelected: (count) => `${count} ta tanlandi`,
  footerTotalRows: "Jami:",

  columnMenuLabel: "Menyu",
  columnMenuShowColumns: "Ustunlarni ko'rsatish",
  columnMenuHideColumn: "Ustunni yashirish",
  columnMenuUnsort: "Tartibni bekor qilish",
  columnMenuSortAsc: "O'sish bo'yicha",
  columnMenuSortDesc: "Kamayish bo'yicha",
  columnMenuFilter: "Saralash",
  columnMenuManageColumns: "Ustunlarni boshqarish",

  columnsPanelTextFieldLabel: "Ustunni topish",
  columnsPanelTextFieldPlaceholder: "Ustun nomi",
  columnsPanelShowAllButton: "Hammasini ko'rsatish",
  columnsPanelHideAllButton: "Hammasini yashirish",

  filterPanelAddFilter: "Saralash qo'shish",
  filterPanelDeleteIconLabel: "O'chirish",
  filterPanelOperator: "Shart",
  filterPanelColumns: "Ustun",
  filterPanelInputLabel: "Qiymat",
  filterPanelInputPlaceholder: "Qiymat",

  toolbarDensity: "Zichlik",
  toolbarDensityCompact: "Zich",
  toolbarDensityStandard: "Oddiy",
  toolbarDensityComfortable: "Keng",
  toolbarExport: "Yuklab olish",
  toolbarExportCSV: "CSV",
  toolbarExportPrint: "Chop etish",

  MuiTablePagination: {
    labelRowsPerPage: "Qatorlar soni:",
    labelDisplayedRows: ({ from, to, count }) =>
      `${from} - ${to} / ${count === -1 ? `${to} dan ko'p` : count}`,
  },
};

export default gridLocale;
